module.exports = __webpack_public_path__ + "static/encouraging.9d2b5720.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/encouraging.png
// module id = 468
// module chunks = 207076274901000